var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5999 4.5999C7.73391 4.5999 4.5999 7.73391 4.5999 11.5999C4.5999 15.4659 7.73391 18.5999 11.5999 18.5999C15.4659 18.5999 18.5999 15.4659 18.5999 11.5999C18.5999 7.73391 15.4659 4.5999 11.5999 4.5999ZM3.3999 11.5999C3.3999 7.07117 7.07117 3.3999 11.5999 3.3999C16.1286 3.3999 19.7999 7.07117 19.7999 11.5999C19.7999 13.6483 19.0488 15.5213 17.807 16.9585L20.4242 19.5756C20.6585 19.81 20.6585 20.1899 20.4242 20.4242C20.1899 20.6585 19.81 20.6585 19.5756 20.4242L16.9585 17.807C15.5213 19.0488 13.6483 19.7999 11.5999 19.7999C7.07117 19.7999 3.3999 16.1286 3.3999 11.5999Z",
    fill: "#262FED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifer);
export default __webpack_public_path__ + "static/media/Magnifer.5b3e6b7afdd1c1176c039416eaa2a202.svg";
export { ForwardRef as ReactComponent };